export default () => `<main class="flex flex-col">
<div class="top-section flex">
</div>
<div class="button-row flex">
</div>
</main>
<footer>2020 Martin Carriel</footer>`;
